import Vue from 'vue'
import appService from '../../server/app.service'
import _ from 'lodash'
import router from '../../router'

import { getField, updateField } from 'vuex-map-fields';

const state = {
    projects: [],
    project: [],
    sites:[],
    bookings:[],
    scriptTypes:[],
    libraries:[],
    scripts:[],
    languages: [],
    languageSelected: 'ita',
    translations: [],
    id: 0,
    collapsedScriptTypes: [],
}

const getters = {
    collapsedScriptTypes: state => state.collapsedScriptTypes,
    projects: state => state.projects,
    project: state => state.project,
    sites: state => state.sites,
    bookings: state => state.bookings,
    scriptTypes: state => state.scriptTypes,
    libraries: state => state.libraries,
    scripts: state => state.scripts,
    languages: state => state.languages,
    languageSelected: state => state.languageSelected,
    translations: state => state.translations,
    getField
}

const actions = {

    loadProjects (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadProjects', { projects: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)
        })
    },

    loadProject (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            context.commit('loadProject', { project: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    createProject (context, credentials) {
        appService.connectToServer(credentials).then(data => {
             context.commit('createProject', { project: data })
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    saveProject (context, credentials) {
        appService.connectToServer(credentials).then(data => {
            if( data.success ) {
                context.commit('saveProjectSuccess')
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addMessage', data)
            }
        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
 

    },

    deleteProject (context, credentials) {
        appService.connectToServer(credentials).then(data => {

            if( data.success ) {
                context.commit('deleteProject', { success: data.success, id: data.id  })
                this.dispatch('addMessage', data)
            } else {
                this.dispatch('addProject', data)
            }

        }).catch(error => {
            this.error = error.toString()
            this.dispatch('addMessage', this.error)

        })
    },

    addSite(context) {
        context.commit('addSite')
    },

    addBooking(context) {
        context.commit('addBooking')
    },

    addScript(context) {
        context.commit('addScript')
    },

    deleteSite(context, id) {
        context.commit('deleteSite', id)
    },

    deleteBooking(context, id) {
        context.commit('deleteBooking', id)
    },

    deleteScript(context, id) {
        context.commit('deleteScript', id)
    },

    languageSelect(context, slug) {
        context.commit('languageSelect', slug)
    },

    resetProject () {
        state.collapsedScriptTypes = []
        state.project = []
        state.sites = []
        state.bookings = []
        state.scriptTypes = []
        state.libraries = []
        state.scripts = []
        state.languageSelected = 'ita'
        state.translations = []
    },

}

const mutations = {

    toggleCollapsedScriptType(state, scriptTypeId) {
        const index = state.collapsedScriptTypes.indexOf(scriptTypeId);
        if (index > -1) {
            state.collapsedScriptTypes.splice(index, 1);
        } else {
            state.collapsedScriptTypes.push(scriptTypeId);
        }
    },

    setCollapsedScriptTypes(state, scriptTypeIds) {
        state.collapsedScriptTypes = scriptTypeIds;
    },

    loadProjects (state, data) {
        state.projects = data.projects.result
    },

    loadProject (state, data) {

        state.project = data.project.result
        state.sites = data.project.data.ProjectSite
        state.bookings = data.project.data.ProjectBooking
        state.scriptTypes = data.project.data.ScriptType
        state.libraries = data.project.data.ProjectLibraries
        state.scripts = data.project.data.Scripts
        state.languages = data.project.data.languages
        state.translations = data.project.data.translations
    },

    createProject (state, data) {
        state.scriptTypes = data.project.data.ScriptType
        state.languages = data.project.data.languages
        state.translations = data.project.data.translations
    },

    saveProjectSuccess () {
        //state.project = []
        //router.replace("/projects")
    },

    deleteProject (state, data) {
        let index = _.findIndex(state.projects, function(o) { return o.id == data.id; });
        state.projects.splice(index, 1)
    },

    addSite (state) {
        state.sites.push({ site: '', id: '', deleted: false });
    },

    addBooking (state) {
        state.bookings.push({ type:'id_albergo', booking: '', id: '', deleted: false });
    },

    addScript (state) {
        state.scripts.push({ platform: '1', type_id: '1', script: '', id: '', deleted: false });
    },

    deleteSite(context, id) {
        state.sites[id].deleted = true;
    },

    deleteBooking(context, id) {
        state.bookings[id].deleted = true;
    },

    deleteScript(context, id) {
        state.scripts[id].deleted = true;
    },

    languageSelect (state, slug) {
        state.languageSelected = slug.slug
    },

    updateField,


}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
}
